import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiGet } from "../api/api";
import CampanhaForm from "../components/CampanhaForm";

export default function CampoFace() {
  const { faceId } = useParams();
  const [face, setFace] = useState(null);
  const [ultimas, setUltimas] = useState([]);

  async function load() {
    setFace(await apiGet(`/faces/${faceId}`));
    setUltimas(await apiGet(`/campanhas/face/${faceId}/ultimos`));
  }

  useEffect(() => {
    load();
  }, [faceId]);

  if (!face) return <div>A carregar…</div>;

  return (
    <div style={{ padding: 15 }}>
      <h2>Face {face.identificador}</h2>

      <p>
        <strong>Inventário:</strong> {face.moldura?.inventario_id}
      </p>

      <CampanhaForm faceId={faceId} onSuccess={load} />

      {ultimas.length > 0 && (
        <div style={{ marginTop: 15, background: "#f5f5f5", padding: 10 }}>
          <strong>Últimos registos</strong>
          <ul>
            {ultimas.map((c) => (
              <li key={c.id}>
                {new Date(c.data_registo).toLocaleDateString()} —{" "}
                <strong>{c.marca}</strong> | {c.campanha}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
